/**
 * Shared primitive size tokens from Figma (Primitives: Sizes):
 * https://www.figma.com/design/6ZVGZowOXbrOXdrcQ9ji7y/Design-system?m=dev&node-id=0-1&vars=1&var-set-id=4-1873
 *
 * Spacing primitives from Figma are a uniform 4px grid (`spacing-N = N * 4`),
 * so they're exposed as helper functions rather than a discrete table:
 *   spacingRaw(4) === 16   // matches Figma's `spacing-4`
 *   spacing(4)    === '16px'
 */
const standardSizeUnit = 4;

export const spacingRaw = (n: number): number => n * standardSizeUnit;
export const spacing = (n: number): string => `${spacingRaw(n)}px`;

export const primitiveSizes = {
    radius: {
        standard: 12,
        medium: 10,
        small: 8,
    },
} as const;

export type PrimitiveSizes = typeof primitiveSizes;
